import updateServiceWorkerCache from 'serviceWorkers/cacheUpdate';
import {PaginatedRequest} from 'utils/types/store';
import {QuestionAttempt, QuestionParams} from './types';

export const updateQuestionAttemptCache = (params: QuestionParams) =>
  updateServiceWorkerCache<PaginatedRequest<QuestionAttempt[]>>({
    cacheName: 'letrusAPI-questionnaireAnswers', // service worker cache group name
    endpoint: `${process.env.REACT_APP_API_URL}/api/v1/question_attempts/?user=${params.user}&question=${params.question}&step=${params.step}&learning_path_user_instance=${params.learning_path_user_instance}`, // cached endpoint url
  });

// utilitary functions
export const cachedQuestionAttempts = {
  update: (
    params: QuestionParams,
    responses?: {option: number}[],
    answer?: string,
  ) => {
    const cachedInstance = updateQuestionAttemptCache(params);
    return cachedInstance((cachedQuestionAttempt) => ({
      ...cachedQuestionAttempt,
      results: [
        {
          ...cachedQuestionAttempt?.results?.[0],
          answer,
          responses: responses as any,
        },
      ],
    }));
  },
};
